import React from "react";

export default function OuterLink({ href, text, children }) {
  return (
    <a href={href} target="_blank" rel="noreferrer noopener">
      {text || children}
    </a>
  );
}
